import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { ReceiptLookupPaymentRecord } from 'store/query/receiptLookup';
import PrivacyFooter from 'components/SqPrivacyFooter';
import ReceiptLookupForm from './ReceiptLookupForm';
import ReceiptLookupOtp from './ReceiptLookupOtp';
import ResultList from './ResultList';
import { Step } from './enums/Step';
import { useParams, useHistory } from 'react-router-dom';
import ReceiptDetail from './ReceiptDetail';
import { ReceiptLookupRouteProps } from './types/RouteProps';
import { BASE_PATH } from './constants/routes';
import { AppState } from 'store';
import { selectBoolFlag } from 'store/featureSlice';
import { AnonymousBoolFlag } from 'routes/profile/models/Flags';

const ReceiptLookup: React.FC = () => {
  const [paymentRecords, setPaymentRecords] = useState<
    ReceiptLookupPaymentRecord[] | undefined
  >();
  const { paymentToken } = useParams<ReceiptLookupRouteProps>();
  const otpEnabled = useSelector((state: AppState) =>
    selectBoolFlag(state, AnonymousBoolFlag.enableReceiptLookupOtp)
  );
  const [currentStep, setCurrentStep] = useState(
    otpEnabled ? Step.OTP : Step.FORM
  );
  const history = useHistory();

  useEffect(() => {
    if (paymentRecords?.length && paymentRecords.length > 1) {
      setCurrentStep(Step.LIST);
    } else if (paymentRecords?.length === 1) {
      history.push(`${BASE_PATH}/${paymentRecords[0].paymentToken}`);
    }
  }, [history, paymentRecords]);

  const renderStep = () => {
    // When OTP is enabled, no screen (including a :paymentToken deep-link) is reachable until the
    // buyer has verified their identity.
    if (currentStep === Step.OTP) {
      return <ReceiptLookupOtp onVerified={() => setCurrentStep(Step.FORM)} />;
    }
    if (paymentToken) {
      return <ReceiptDetail />;
    }
    switch (currentStep) {
      case Step.LIST: {
        return (
          <ResultList
            paymentRecords={paymentRecords ?? []}
            setCurrentStep={setCurrentStep}
          />
        );
      }
      default: {
        return (
          <ReceiptLookupForm
            paymentRecords={paymentRecords}
            setPaymentRecords={setPaymentRecords}
          />
        );
      }
    }
  };

  return (
    <>
      {renderStep()}
      <PrivacyFooter />
    </>
  );
};

export default ReceiptLookup;
